<template>
  <div class="section section-landpresale" id="landpresale-section" data-background-color="black">
    <div data-aos="fade-left" class="img_deco_06">
    </div> 
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="text-center col-md-12 col-lg-12">
          <h1 data-aos="fade-up" class="title deco2">{{$t(`Pre-sale`)}}</h1>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <div class="row">
            <div class="col">
              <h3 class="title" style="color: #27a784; text-transform: uppercase;">{{$t(`Coming soon`)}}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
  </div>
</template>
<script>
export default {};
</script>
<style></style>
